import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    debug: false,
    interpolation: {
      escapeValue: false, // React ya lo hace
    },
    backend: {
      // lo vamos a sobreescribir dinámicamente en el Provider
      loadPath: '/locales/{{lng}}.json'
    }
  });

export default i18n;
